import React, {useEffect, useState} from 'react';

import Header2 from '../../../../../../components/headers/header2';
import {Column, Row} from '../../../../../../components/layout';
import AppDrapDropFileInput from '../../../../../../components/app-drap-drop-file-input';
import './styles.scss';
import AppButton from '../../../../../../components/app-button';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {addToWizard} from '../../../../../../store/actions';
import {InvoiceValidationProps} from '../InvoiceValidation';
import {get, postWithCustomHeaders} from '../../../../../../api/api';
import {
  uriExpenseSubmission,
  uriGetDocumentTypes,
} from '../../../../../../api/endpoints';
import {createGUID} from '../../../../../../util/utility';
import PopupList from '../../../../../../components/popup-list';
import * as fonts from '../../../../../../util/fonts';
import colors from '../../../../../../util/colors';
import {useLocation} from 'react-router';

function AttachFiles({
  preAuth,
  wizard,
  addToWizard,
  labels,
  labelsPreAuthorizations,
  showPopup,
  titleOfButton,
  nextStep,
  selectedBu,
  nextStepFlag,
  labelFiles,
  patients,
  documentTypes,
}: InvoiceValidationProps) {
  const [files, setFiles] = useState<any[]>([]);
  const [submitting, setSubmitting] = useState(false);
  const [show, setShow] = useState(false);
  const [filesAdded, setFilesAdded] = useState<any[]>();
  const onFileAdd = (addedFiles: any[]) => {
    setShow(showPopup);
    setFilesAdded(addedFiles);
  };

  return (
    <Column className="attach-files-container">
      <Header2
        className="attach-files-title"
        style={{...fonts.ML, ...fonts.Bold, color: colors.black}}>
        {files.length > 0
          ? preAuth
            ? labelsPreAuthorizations.preAuthorizations_attachOtherDocuments
            : labels?.createRefund_moreDocumentstext
          : labelFiles}
      </Header2>
      <Row>
        <AppDrapDropFileInput
          preAuth={preAuth}
          files={files}
          setFiles={setFiles}
          newFilesName={labels?.createRefund_invoice}
          onFileAdd={onFileAdd}
          filesSizeLimit={true}
        />
      </Row>
      <Row className="attach-files-confirm-button-row">
        <AppButton
          className="attach-files-confirm-button"
          disabled={files.length === 0 || submitting}
          onClick={async () => {
            try {
              setSubmitting(true);
              const {patientValidation} = wizard;

              const sessionId = createGUID();

              const formData = new FormData();
              formData.append('buId', patients.buId);
              formData.append('memId', patients.memId);
              formData.append('sessionId', sessionId);
              files.forEach(({file}) => {
                formData.append('documents', file);
              });
              if (!showPopup) {
                await postWithCustomHeaders(uriExpenseSubmission(), formData);
              }
              addToWizard({
                attachFiles: {
                  sessionId: sessionId,
                  files,
                },
              });
            } catch (e: any) {
            } finally {
              setSubmitting(false);
            }
            if (nextStepFlag) {
              nextStep();
            }
          }}>
          {titleOfButton}
        </AppButton>
      </Row>
      <PopupList
        onSubmit={(value) => {
          let newFiles = [...files];
          newFiles.forEach((item) => {
            let idAddedFile = filesAdded?.find((id) => item.id === id);
            if (idAddedFile) {
              item.name = value;
            }
            setShow(false);
          });
          setFiles(newFiles);
        }}
        onClose={() => {
          const newFiles = files;
          newFiles.pop();
          setFiles(newFiles);
          setShow(false);
        }}
        title={labelsPreAuthorizations?.preAuthorizations_documentType}
        show={show}
        list={documentTypes}
        setShowModal={setShow}
        titleOfButton={labels?.createRefund_confirm}></PopupList>
    </Column>
  );
}

const mapStateToProps = ({user, wizard, strings, patients}: any) => ({
  user: user.value,
  wizard: wizard.value,
  labels: strings.value.pt.createRefund,
  labelsPreAuthorizations: strings.value.pt.preAuthorizations,
  patients: patients.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AttachFiles)
);
